import MemberDelete from './memberDelete'

export default MemberDelete;